import BaseModelAPI from '../BaseModelAPI';

export default class VendorList extends BaseModelAPI {

	static entity = 'vendorlist'
	static entityName = 'vendor';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
